import { render, staticRenderFns } from "./HbMiniProfileItem.vue?vue&type=template&id=7f8fd4cc&scoped=true&"
import script from "./HbMiniProfileItem.vue?vue&type=script&lang=js&"
export * from "./HbMiniProfileItem.vue?vue&type=script&lang=js&"
import style0 from "./HbMiniProfileItem.vue?vue&type=style&index=0&id=7f8fd4cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8fd4cc",
  null
  
)

export default component.exports